/**
 * @flow
 */

import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import App from './app/App'
import store from './app/store'

// Find the container element
const container = document.querySelector('#app')

// Create a root
const root = createRoot(container)

// Render the App component to the root
root.render(
  <Router>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>,
)
